<h1 mat-dialog-title aria-live="polite">Log out</h1>

<mat-dialog-content>
  <div>Are you sure you want to logout?</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="is-taller">
    <div class="level">
      <div class="level-item">
        <button class="bofa--button secondary" [mat-dialog-close]="false">Cancel</button>
      </div>

      <div class="level-item">
        <button class="bofa--button secondary outlined" [mat-dialog-close]="true">Logout</button>
      </div>
    </div>
  </div>
</mat-dialog-actions>
